import React from "react";
import "./ButtonWithdrawAllEarning3.css";

function ButtonWithdrawAllEarning3(props) {
  const { className } = props;

  return (
    <div className={`button-withdraw-all-earning-15 ${className || ""}`}>
      <div className="shop-now-5 avenir-medium-black-7px">SHOP NOW</div>
    </div>
  );
}

export default ButtonWithdrawAllEarning3;
